import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import VCardCreate from './pages/VCardCreate';
import VCardEdit from './pages/VCardEdit';
import VCardView from './pages/VCardView';
import AuthCallback from './pages/AuthCallback';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import RefundPolicy from './pages/RefundPolicy';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function AppContent() {
  const location = useLocation();
  // Hide navbar and footer on vCard view page (public vCard display)
  const showNavbar = !location.pathname.startsWith('/vcard/') || location.pathname.startsWith('/vcard/create') || location.pathname.startsWith('/vcard/edit');
  const showFooter = !location.pathname.startsWith('/vcard/') || location.pathname.startsWith('/vcard/create') || location.pathname.startsWith('/vcard/edit');

  return (
    <div className="App">
      {showNavbar && <Navbar />}
      <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route path="/vcard/create" element={<VCardCreate />} />
            <Route
              path="/vcard/edit/:id"
              element={
                <PrivateRoute>
                  <VCardEdit />
                </PrivateRoute>
              }
            />
            <Route path="/vcard/:uniqueId" element={<VCardView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {showFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;

